import { ClientRepository } from '../../domain/repositories/client.repository';
import { ClientEntity, ClientProps } from '../../domain/entities/client.entity';
import { IHttpClient } from '../../application/interfaces/http-client.interface';
import { resolveMediaUrl } from '../utils/media-url.helper';

interface ApiResponse<T> {
  success: boolean;
  data: T;
  message?: string;
}

export class HttpClientRepository implements ClientRepository {
  constructor(private readonly httpClient: IHttpClient) {}

  public async getClients(): Promise<ClientEntity[]> {
    try {
      const res = await this.httpClient.get<ApiResponse<any[]>>('/clients');
      if (!res.success || !Array.isArray(res.data)) {
        return [];
      }
      return res.data.map((raw: any) =>
        new ClientEntity({
          id: raw.id ?? raw._id,
          name: raw.name ?? raw._name,
          slug: raw.slug ?? raw._slug,
          logoUrl: resolveMediaUrl(raw.logoUrl ?? raw.logo_url ?? raw._logoUrl),
          websiteUrl: raw.websiteUrl ?? raw.website_url ?? raw._websiteUrl ?? null,
          category: raw.category ?? raw._category ?? null,
          status: raw.status ?? raw._status ?? 'active',
          displayOrder: Number(raw.displayOrder ?? raw.display_order ?? raw._displayOrder ?? 0),
        })
      );
    } catch {
      return [];
    }
  }

  public async createClient(data: Partial<ClientProps>): Promise<ClientEntity> {
    const res = await this.httpClient.post<ApiResponse<any>>('/clients', data);
    if (!res.success || !res.data) {
      throw new Error(res.message || 'Error al registrar la empresa cliente');
    }
    const raw = res.data;
    return new ClientEntity({
      id: raw.id ?? raw._id,
      name: raw.name ?? raw._name,
      slug: raw.slug ?? raw._slug,
      logoUrl: raw.logoUrl ?? raw.logo_url ?? raw._logoUrl,
      websiteUrl: raw.websiteUrl ?? raw.website_url ?? raw._websiteUrl ?? null,
      category: raw.category ?? raw._category ?? null,
      status: raw.status ?? raw._status ?? 'active',
      displayOrder: Number(raw.displayOrder ?? raw.display_order ?? raw._displayOrder ?? 0),
    });
  }

  public async deleteClient(id: string): Promise<void> {
    const res = await this.httpClient.delete<ApiResponse<null>>(`/clients/${encodeURIComponent(id)}`);
    if (!res.success) {
      throw new Error(res.message || 'Error al eliminar la empresa cliente');
    }
  }
}
